import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/common/Navbar";
import { Home } from "./pages/Home";
import { Portfolio } from "./pages/Portfolio";
// import { About } from "./pages/About";
import { Services } from "./pages/Services";
// import { Contact } from "./pages/Contact";
import "./styles/globals.module.css";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            {/*<Route path="/about" element={<About />} />*/}
            <Route path="/services" element={<Services />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
